/**
 * Menu container component.
 *
 * Wraps Bloom's Container with shadow override CSS.
 * Bloom hardcodes Framer Motion shadows that we override.
 */

import type { ReactNode } from "react";
import * as BloomMenu from "bloom-menu";

const CONTAINER_CLASS = "primaris-menu-container";

const shadowOverrideCSS = `
  .${CONTAINER_CLASS} {
    box-shadow: none !important;
  }
`;

let styleInjected = false;
function injectShadowOverride() {
  if (styleInjected || typeof document === "undefined") {
    return;
  }
  const style = document.createElement("style");
  style.textContent = shadowOverrideCSS;
  document.head.appendChild(style);
  styleInjected = true;
}

export interface MenuContainerProps {
  children: ReactNode;
  buttonRadius?: number;
  buttonSize?: number;
  menuRadius?: number;
  menuWidth?: number;
}

export function MenuContainer({
  children,
  buttonRadius,
  buttonSize,
  menuRadius,
  menuWidth,
}: MenuContainerProps) {
  injectShadowOverride();

  return (
    <BloomMenu.Container
      className={CONTAINER_CLASS}
      {...(buttonRadius !== undefined && { buttonRadius })}
      {...(buttonSize !== undefined && { buttonSize })}
      {...(menuRadius !== undefined && { menuRadius })}
      {...(menuWidth !== undefined && { menuWidth })}
    >
      {children}
    </BloomMenu.Container>
  );
}
